import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/bh/topnotch.webp";

function Banner(props) {
  return (
    <div className="mobileapp_gcc p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h2>
                Build Your Business Identity Leveraging the Custom Approach of
                Our App Development Company
              </h2>
              <p>
                We believe that every business is unique, having its own
                principles that define its motive. While transforming any
                business through app development Bahrain, our experts ensure to
                inject that element into the product that defines your
                objectives.
              </p>
              <p>
                TekRevol is famous for its innovation-driven approach with a
                custom strategy to digitize any brand with its mobile
                applications. When a client consults with us for their project,
                we deeply understand their vision and offer a solution that fits
                right according to their business requirements.
              </p>
              <p>
                Moreover, our app developers in Bahrain have a firm grip over
                different stacks to build diverse applications. We encourage
                custom solutions to create our client’s apps, so they can have a
                unique identity in the market giving them a competitive edge.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Discuss Your Project!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="app development company"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
